import './App.css';
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/layout';
import Home from './components/pages/home';
import LoginPage from './components/pages/login';
import Store from './components/pages/products';
import CartProvider from './components/cartContext';
import SpecificProduct from './components/pages/specificProductPage';
import ProfilePage from './components/pages/profile';
import CheckoutPage from './components/pages/checkout';
import SuccessPage from './components/pages/successPage';
import Dokumentasjon from './components/pages/dokumentasjon';
import AdminHome from './components/pages/admin/home';
import AdminNorge from './components/pages/admin/norge';
import AdminVerkstedOversikt from './components/adminVerkstedOversikt';
// import Test from './components/test/test';
import AdminSverige from './components/pages/admin/sverige';
import AdminFinland from './components/pages/admin/finland';
import StoreHome from './components/pages/storeHome';
import HerkulesProdukter from './components/herkulesProdukter';
import CeletteProdukter from './components/celetteProdukter';
import VpAdminHome from './components/pages/VP/admin';
import VPadminNettbutikk from './components/pages/VP/nettbutikk';
import VPVerkstedSide from './components/pages/VP/verksteder';
import VPadminKjedeside from './components/pages/VP/kjeder';
import VPspesVerksted from './components/pages/VP/verksted';
import VpDokumentasjonsSide from './components/pages/VP/dokumentasjon';
import { DynamicServiceForm } from './components/dynamicServiceForm';
import VpAdminOrdrePage from './components/pages/VP/ordre';

function App() {

  return (
    <div className="App">
      <CartProvider>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<StoreHome />}/>
            <Route path="login" element={<LoginPage />}/>
            <Route path="home" element={<Home />}/>
            <Route path="store" element={<StoreHome />}/>
            <Route path="/store/konigstein" element={<Store />}/>
            <Route path="/store/herkules" element={<HerkulesProdukter />}/>
            <Route path="/store/celette" element={<CeletteProdukter />}/>
            <Route path="store/product/:id" element={<SpecificProduct />}/>
            <Route path="/product/:id" element={<SpecificProduct />} />
            <Route path="profile" element={<ProfilePage />}/>
            <Route path="checkout" element={<CheckoutPage />}/>
            <Route path="success" element={<SuccessPage />}/>
            <Route path="dokumentasjon" element={<Dokumentasjon />}/>
            <Route path="/admin/home" element={<AdminHome />}/>
            <Route path="/admin/norge" element={<AdminNorge />}/>
            <Route path="/admin/sverige" element={<AdminSverige />}/>
            <Route path="/admin/finland" element={<AdminFinland />}/>
            <Route path="/admin/norge/alna" element={<AdminVerkstedOversikt />}/>
            <Route path="/admin/verksted/:id" element={<AdminVerkstedOversikt />} />
            <Route path="/VP/admin/" element={<VpAdminHome />} />
            <Route path="/VP/admin/ordre" element={<VpAdminOrdrePage />} />
            <Route path="/VP/admin/dokumentasjon/:id" element={<VpDokumentasjonsSide />} />
            <Route path="/VP/admin/service" element={<DynamicServiceForm />} />
            <Route path="/VP/admin/verksteder" element={<VPVerkstedSide />} />
            <Route path="/VP/admin/nettbutikk" element={<VPadminNettbutikk />} />
            <Route path="/VP/admin/kjeder" element={<VPadminKjedeside />} />
            <Route path="/VP/admin/verksted/:id" element={<VPspesVerksted />} />
            <Route path="/VP/admin/dokumentasjon/:id" element={<VpDokumentasjonsSide />} />
          </Route>
        </Routes>
      </CartProvider>
    </div>
  );
}

export default App;
